// - src/modules/typography-panel/typography-panel.js
document.addEventListener('DOMContentLoaded', () => {
  const fuenteSelect = document.getElementById('fuenteSelect');
  if (!fuenteSelect) return;

  /* -----------------------------------------
     Vista previa del nombre
  ----------------------------------------- */
  const inputNombre = document.getElementById('inputNombre');
  const previewNombre = document.getElementById('previewNombre');

  inputNombre.addEventListener('input', () => {
    previewNombre.textContent = inputNombre.value || 'Jubesa';
  });

  /* -----------------------------------------
     Iniciales ornamentales
  ----------------------------------------- */
  const inputInicialPrimera = document.getElementById('inputInicialPrimera');
  const previewInicialPrimera = document.getElementById(
    'previewInicialPrimera',
  );
  const fuenteInicialPrimera = document.getElementById('fuenteInicialPrimera');

  const inputInicialSegunda = document.getElementById('inputInicialSegunda');
  const previewInicialSegunda = document.getElementById(
    'previewInicialSegunda',
  );
  const fuenteInicialSegunda = document.getElementById('fuenteInicialSegunda');

  // Letra primera palabra
  inputInicialPrimera.addEventListener('input', () => {
    previewInicialPrimera.textContent = inputInicialPrimera.value || 'A';
  });

  // Letra segunda palabra
  inputInicialSegunda.addEventListener('input', () => {
    previewInicialSegunda.textContent = inputInicialSegunda.value || 'Z';
  });

  // Fuente primera inicial
  fuenteInicialPrimera.addEventListener('change', () => {
    previewInicialPrimera.style.fontFamily = `"${fuenteInicialPrimera.value}"`;
  });

  // Fuente segunda inicial
  fuenteInicialSegunda.addEventListener('change', () => {
    previewInicialSegunda.style.fontFamily = `"${fuenteInicialSegunda.value}"`;
  });

  // Defaults
  previewInicialPrimera.style.fontFamily = `"Ainan Trial"`;
  previewInicialSegunda.style.fontFamily = `"Luxurious Script"`;

  /* -----------------------------------------
     Minúsculas
  ----------------------------------------- */
  const inputMinusculas = document.getElementById('inputMinusculas');
  const previewMinusculas = document.getElementById('previewMinusculas');

  inputMinusculas.addEventListener('input', () => {
    previewMinusculas.textContent =
      inputMinusculas.value || 'abcdefghijklmnopqrstuvwxyz';
  });

  /* -----------------------------------------
     Texto largo
  ----------------------------------------- */
  const inputTexto = document.getElementById('inputTexto');
  const previewTexto = document.getElementById('previewTexto');

  inputTexto.addEventListener('input', () => {
    previewTexto.textContent =
      inputTexto.value ||
      'La luz asciende en silencio, como un trazo caligráfico que respira propósito.';
  });

  /* -----------------------------------------
     Comparador A/B
  ----------------------------------------- */
  const fuenteA = document.getElementById('fuenteA');
  const fuenteB = document.getElementById('fuenteB');
  const previewA = document.getElementById('previewA');
  const previewB = document.getElementById('previewB');

  document.querySelectorAll('.inputComparador').forEach((input) => {
    input.addEventListener('input', () => {
      const target = input.dataset.target;
      const preview = document.getElementById('preview' + target);
      preview.textContent = input.value || 'Jubesa';
    });
  });

  function aplicarFuente(elemento, fuente) {
    if (fuente && elemento) {
      elemento.style.fontFamily = `'${fuente}', cursive`;
    }
  }

  fuenteSelect.addEventListener('change', () => {
    const fuente = fuenteSelect.value;
    aplicarFuente(previewNombre, fuente);
    aplicarFuente(previewInicialPrimera, fuente);
    aplicarFuente(previewMinusculas, fuente);
    aplicarFuente(previewTexto, fuente);
  });

  fuenteA.addEventListener('change', () => {
    aplicarFuente(previewA, fuenteA.value);
  });

  fuenteB.addEventListener('change', () => {
    aplicarFuente(previewB, fuenteB.value);
  });
});
